import { IterableElement, ValueOf } from 'type-fest'

export const Blockchain = {
  BITCOIN: 'BITCOIN',
  ETHEREUM: 'ETHEREUM',
  BINANCE_SMART_CHAIN: 'BINANCE_SMART_CHAIN',
  TRON: 'TRON',
  POLYGON: 'POLYGON',
  BASE: 'BASE',
  SOLANA: 'SOLANA',
  ARBITRUM: 'ARBITRUM',
  LITECOIN: 'LITECOIN'
} as const

export type Blockchain = ValueOf<typeof Blockchain>

export const BLOCKCHAINS = Object.values(Blockchain)

// Blockchains with evm machine
export const EVM_BLOCKCHAIN = [
  Blockchain.ETHEREUM,
  Blockchain.BINANCE_SMART_CHAIN,
  Blockchain.POLYGON,
  Blockchain.BASE,
  Blockchain.ARBITRUM
]
export const TVM_BLOCKCHAIN = [Blockchain.TRON]
export const SVM_BLOCKCHAIN = [Blockchain.SOLANA]
export const VM_BLOCKCHAIN = [...EVM_BLOCKCHAIN, ...TVM_BLOCKCHAIN, ...SVM_BLOCKCHAIN]

export type EvmBlockchain = IterableElement<typeof EVM_BLOCKCHAIN>
export type TvmBlockchain = IterableElement<typeof TVM_BLOCKCHAIN>
export type SvmBlockchain = IterableElement<typeof SVM_BLOCKCHAIN>
export type VmBlockchain = EvmBlockchain | TvmBlockchain | SvmBlockchain
